var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4534 14.8846H22.9786V13.551C22.9786 13.2468 22.7338 13 22.432 13H17.568C17.2662 13 17.0214 13.2468 17.0214 13.551V14.8846H14.5466C14.2449 14.8846 14 15.1314 14 15.4355C14 15.7397 14.2449 15.9865 14.5466 15.9865H25.4534C25.7551 15.9865 26 15.7397 26 15.4355C26 15.1314 25.7551 14.8846 25.4534 14.8846ZM23.6933 17.1525C23.6933 16.8483 23.9381 16.6015 24.2399 16.6015C24.5416 16.6015 24.7865 16.8476 24.7865 17.1525V25.4921C24.7865 26.3235 24.116 27 23.2918 27H16.7096C15.8847 27 15.2135 26.3228 15.2135 25.4921V17.1525C15.2135 16.8483 15.4584 16.6015 15.7601 16.6015C16.0619 16.6015 16.3067 16.8483 16.3067 17.1525L16.306 25.4921C16.306 25.7159 16.4868 25.8981 16.7089 25.8981H23.2918C23.5132 25.8981 23.6933 25.7159 23.6933 25.4921V17.1525ZM19.3011 24.0574V17.1525C19.3011 16.8483 19.0563 16.6015 18.7545 16.6015C18.4527 16.6015 18.2079 16.8483 18.2079 17.1525V24.0574C18.2079 24.3615 18.4527 24.6083 18.7545 24.6083C19.0563 24.6083 19.3011 24.3623 19.3011 24.0574ZM21.7923 24.0574V17.1525C21.7923 16.8483 21.5475 16.6015 21.2457 16.6015C20.9439 16.6015 20.6991 16.8483 20.6991 17.1525V24.0574C20.6991 24.3615 20.9439 24.6083 21.2457 24.6083C21.5475 24.6083 21.7923 24.3623 21.7923 24.0574ZM18.1146 14.8848H21.8854V14.1021H18.1146V14.8848Z",
    fill: "#116F9A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 1.5,
    stroke: "#116F9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.54040b183c4d934be43d61d214784b5a.svg";
export { ForwardRef as ReactComponent };